import { ClientPortalPaymentModes } from "../../Common/organisationInfo";
import { BookingType, IStore, Step } from "../DataTypes/storeTypes";

export function selectPortalPaymentMode(state: IStore): ClientPortalPaymentModes {
    const organisationInfo = state.initialSettings.accountInitialSettings.organisationInfo;

    return state.initialSettings.type === BookingType.Client
        ? organisationInfo.portalPayments
        : organisationInfo.groupPortalPayments;
}

export function selectIsStripeConnected(state: IStore): boolean {
    const defaultBusinessStripeAccount = state.initialSettings.accountInitialSettings.organisationInfo.stripeAccount;

    const availablePractitioners = state.providers;
    const selectedPractitionerId = state.stepsInfo[Step.Provider]?.id;
    const practitionerStripeAccount = availablePractitioners.find((x) => x.id == selectedPractitionerId)?.stripeAccount;

    return !!defaultBusinessStripeAccount || !!practitionerStripeAccount;
}
